import { Link } from 'react-router-dom';
import { articles } from '@/mocks/homeData';

const listImages = [
  'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20film%20production%20scene%20with%20traditional%20costumes%2C%20warm%20golden%20lighting%2C%20professional%20film%20crew%2C%20cinematic%20atmosphere&width=800&height=500&seq=article-list-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20stage%20with%20golden%20trophy%2C%20warm%20prestigious%20lighting%2C%20celebratory%20corporate%20event%20photography&width=800&height=500&seq=article-list-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Festive%20Chinese%20cinema%20with%20red%20lanterns%20and%20movie%20posters%2C%20warm%20holiday%20atmosphere%2C%20excited%20crowd&width=800&height=500&seq=article-list-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20phone%20displaying%20video%20app%20on%20minimal%20desk%2C%20warm%20natural%20light%2C%20tech%20lifestyle%20product%20photography&width=800&height=500&seq=article-list-04&orientation=landscape',
];

export default function ArticleListPage() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.douhuavideo.com/' },
          { '@type': 'ListItem', position: 2, name: '热门资讯', item: 'https://www.douhuavideo.com/articles' },
        ],
      },
      {
        '@type': 'CollectionPage',
        name: '豆花视频 - 热门资讯',
        description: '了解豆花视频平台最新动态、影视资讯、产品更新等内容。',
        url: 'https://www.douhuavideo.com/articles',
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <main className="pt-16">
        <nav className="w-full px-4 md:px-6 py-4 bg-background-50 border-b border-background-200/70" aria-label="面包屑导航">
          <ol className="flex items-center gap-2 text-sm text-foreground-500">
            <li><Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-xs"></i></li>
            <li className="text-foreground-900 font-medium">热门资讯</li>
          </ol>
        </nav>

        <section className="w-full py-10 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
              热门资讯
            </h1>
            <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
              了解豆花视频最新动态、影视资讯与产品更新
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              {articles.map((article, idx) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
                >
                  <div className="relative w-full aspect-[16/10] overflow-hidden">
                    <img
                      src={listImages[idx]}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      title={`豆花视频 - ${article.title}`}
                    />
                    <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium rounded bg-secondary-100 text-secondary-700">
                      {article.category}
                    </span>
                  </div>
                  <div className="p-5">
                    <h2 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-4">
                      {article.summary}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.date}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.readCount} 阅读
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}